export default "__VITE_PUBLIC_ASSET__73c8a95c__"